import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import BreakingNews from '../components/BreakingNews';
import FeaturedArticle from '../components/FeaturedArticle';
import NewsCard from '../components/NewsCard';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const HomePage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/articles?limit=10`);
      setArticles(response.data);
    } catch (error) {
      console.error('Failed to fetch articles:', error);
    } finally {
      setLoading(false);
    }
  };

  const featuredArticle = articles.find((article) => article.is_featured);
  const latestArticles = articles.filter((article) => !article.is_featured);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <BreakingNews />

      {/* 50 Years Anniversary Banner */}
      <div className="bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-4 mb-4 md:mb-0">
              <div className="flex items-center space-x-2">
                <span className="text-4xl font-bold">৫০</span>
                <div className="text-left">
                  <p className="text-sm font-semibold">বছর সেবার</p>
                  <p className="text-xs text-red-100">Years of Service</p>
                </div>
              </div>
              <div className="h-12 w-px bg-red-300 hidden md:block"></div>
              <div className="text-left">
                <p className="text-lg font-bold">১৯৭৪ - ২০২৪</p>
                <p className="text-sm text-red-100">স্বর্ণ জয়ন্তী • Golden Jubilee</p>
              </div>
            </div>
            <a href="/50-years">
              <button className="bg-yellow-400 hover:bg-yellow-300 text-red-900 font-bold px-6 py-3 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
                View Celebration →
              </button>
            </a>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        {loading ? (
          <div className="text-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading news...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content */}
            <div className="lg:col-span-2">
              {/* Featured Article */}
              {featuredArticle && (
                <div className="mb-8">
                  <FeaturedArticle article={featuredArticle} />
                </div>
              )}

              {/* Latest News Section */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b-4 border-red-600 pb-2 inline-block">
                  Latest News
                </h2>
                {latestArticles.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                    {latestArticles.map((article) => (
                      <NewsCard key={article.id} article={article} />
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12 bg-white rounded-lg">
                    <p className="text-gray-500">No articles available yet. Check back soon!</p>
                  </div>
                )}
              </div>
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <Sidebar />
            </div>
          </div>
        )}
      </div>

      <Footer />
      
      {/* Made with Emergent Badge */}
      <div className="fixed bottom-4 right-4 z-50">
        <a
          href="https://app.emergent.sh/?utm_source=emergent-badge"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center space-x-2 bg-black text-white px-4 py-2 rounded-full shadow-lg hover:bg-gray-800 transition-colors duration-200"
        >
          <span className="text-sm font-semibold">Made with Emergent</span>
        </a>
      </div>
    </div>
  );
};

export default HomePage;